/**
 * Expense Filters Component
 */
import React from 'react';
import { Label } from '../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Filter, ChevronDown, ChevronUp } from 'lucide-react';
import { CATEGORIES, REIMBURSEMENT_STATUS } from './config';

const MONTHS = [
  { value: '01', label: 'January' },
  { value: '02', label: 'February' },
  { value: '03', label: 'March' },
  { value: '04', label: 'April' },
  { value: '05', label: 'May' },
  { value: '06', label: 'June' },
  { value: '07', label: 'July' },
  { value: '08', label: 'August' },
  { value: '09', label: 'September' },
  { value: '10', label: 'October' },
  { value: '11', label: 'November' },
  { value: '12', label: 'December' },
];

const ExpenseFilters = ({ 
  showFilters, 
  setShowFilters, 
  categoryFilter, 
  setCategoryFilter, 
  statusFilter, 
  setStatusFilter,
  monthFilter,
  setMonthFilter,
  yearFilter,
  setYearFilter,
  availableYears
}) => {
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-xl p-4">
      <button
        onClick={() => setShowFilters(!showFilters)}
        className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors w-full"
        data-testid="expense-filters-toggle"
      >
        <Filter className="h-4 w-4" />
        <span className="font-medium">Filters</span>
        {showFilters ? <ChevronUp className="h-4 w-4 ml-auto" /> : <ChevronDown className="h-4 w-4 ml-auto" />}
      </button>
      
      {showFilters && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-4 pt-4 border-t border-slate-700">
          <div className="space-y-2">
            <Label className="text-slate-400">Year</Label>
            <Select value={yearFilter} onValueChange={setYearFilter}>
              <SelectTrigger className="bg-slate-900 border-slate-600 text-white" data-testid="expense-year-filter">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="bg-slate-800 border-slate-600">
                <SelectItem value="all" className="text-white hover:bg-slate-700">All Years</SelectItem>
                {(availableYears || []).map(y => (
                  <SelectItem key={y} value={y} className="text-white hover:bg-slate-700">{y}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label className="text-slate-400">Month</Label>
            <Select value={monthFilter} onValueChange={setMonthFilter}>
              <SelectTrigger className="bg-slate-900 border-slate-600 text-white" data-testid="expense-month-filter">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="bg-slate-800 border-slate-600">
                <SelectItem value="all" className="text-white hover:bg-slate-700">All Months</SelectItem>
                {MONTHS.map(m => (
                  <SelectItem key={m.value} value={m.value} className="text-white hover:bg-slate-700">{m.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label className="text-slate-400">Category</Label>
            <Select value={categoryFilter} onValueChange={setCategoryFilter}>
              <SelectTrigger className="bg-slate-900 border-slate-600 text-white" data-testid="expense-category-filter">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="bg-slate-800 border-slate-600">
                <SelectItem value="all" className="text-white hover:bg-slate-700">All Categories</SelectItem>
                {Object.entries(CATEGORIES).map(([key, config]) => (
                  <SelectItem key={key} value={key} className="text-white hover:bg-slate-700">
                    {config.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label className="text-slate-400">Reimbursement Status</Label>
            <Select value={statusFilter} onValueChange={setStatusFilter}>
              <SelectTrigger className="bg-slate-900 border-slate-600 text-white" data-testid="expense-status-filter">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="bg-slate-800 border-slate-600">
                <SelectItem value="all" className="text-white hover:bg-slate-700">All Statuses</SelectItem>
                {Object.entries(REIMBURSEMENT_STATUS).map(([key, config]) => (
                  <SelectItem key={key} value={key} className="text-white hover:bg-slate-700">
                    {config.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExpenseFilters;
